/* unplugin-vue-components disabled */import { render } from "./company-search.vue?vue&type=template&id=19b63321&scoped=true"
import script from "./company-search.vue?vue&type=script&lang=js"
export * from "./company-search.vue?vue&type=script&lang=js"

import "./company-search.vue?vue&type=style&index=0&id=19b63321&lang=stylus"
import "./company-search.vue?vue&type=style&index=1&id=19b63321&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b63321"],['__file',"src/components/search-dropdown/company-search.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19b63321"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19b63321', __exports__)) {
    api.reload('19b63321', __exports__)
  }
  
  module.hot.accept("./company-search.vue?vue&type=template&id=19b63321&scoped=true", () => {
    api.rerender('19b63321', render)
  })

}


export default __exports__